<template>
  <div class="sys_config_box">
    <div class="topOperation">
      <div class="top-left">
        <div><ShowNavHead/></div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">姓名</div>
            <el-input size="small" v-model="listQuery.username" @keyup.enter.native="searchHandle"></el-input>
            <el-button type="success" plain size="small" @click="searchHandle" style="margin-left:10px;">搜索</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统</el-breadcrumb-item>
          <el-breadcrumb-item>基础配置</el-breadcrumb-item>
          <el-breadcrumb-item>基础设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs v-model="activeName" type="card" class="p_roster_table">
        <el-tab-pane label="消息通知设置" name="first"></el-tab-pane>
      </el-tabs>
      <div class="sys_config_table">
        <div class="sys_btns">
            <el-button type="primary" size="small" @click="addHandle">新增通知用户</el-button>
        </div>
        <el-table :data="tableData" :max-height="tableHeight-180" v-loading="listLoading">
          <el-table-column align="center" label="序号" width="80px">
                <template slot-scope="{$index}">
                    <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.pagecount) + Number($index) + 1}}</span>
                </template>
          </el-table-column>
          <el-table-column label="姓名" align="center" prop="Username" min-width="100px"></el-table-column>
          <el-table-column label="可用条数" align="center" prop="SmsavailableNum" min-width="100px"></el-table-column>
          <el-table-column label="操作时间" align="center" min-width="100px">
            <template slot-scope="{row}">
              <span>{{row.UpdateTime?row.UpdateTime.replace('T',' '):''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" min-width="80px">
            <template slot-scope="{row}">
              <el-button v-if="row.UserId != 'caa39434-539c-40cb-95d6-31b215f0f9dc'" plain type="primary" size="mini" @click="editHandle(row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="listQuery.pagecount"
            layout="total,sizes,prev,pager,next,jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增/修改弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
        <el-form :model="formQuery" ref="formData" :rules="formRule" label-width="110px" class="sys_dialog_box">
          <el-form-item label="用户：" prop="meUserId">
            <el-select v-model="formQuery.meUserId" size="small" placeholder="" filterable>
              <el-option v-for="(item,index) in userList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可用次数：" prop="SmsavailableNum">
            <el-input type="number" v-model="formQuery.SmsavailableNum" size="small" min="0"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible=false">取消</el-button>
            <el-button size="small" type="primary" @click="confirmEdit">确定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import xz from "@/common";
export default {
  data() {
    return {
        tablePath: this.$store.state.EMP.tablePath,
        tableHeight:0,
        dialogTitle:'新增通知用户',
        listLoading:false,
        listQuery:{
            currpage: 1,
            pagecount: 10,
            username:''
        },
        totalcount: 0,
        dialogVisible: false,
        formQuery: {
            meUserId: '',
            UseridSet:'',//设置
            SmsavailableNum:0//条数
        },
        formRule:{
            meUserId: [{
            required: true,
            message: "请选择人员",
            trigger: "change"
          }],
          SmsavailableNum: [{
            required: true,
            message: "请输入次数",
            trigger: "blur"
          }]
        },
        userList:[],
        tableData: [],
        // 按钮权限参数
        butQuery:{
          roletype:'',
          page:'customList'
        },
        activeName:'first',
        //角色类型
        roleType: ''
    }
  },
  created() {
    this.roleType = localStorage.loginRoletype
    this.butQuery.roletype = localStorage.loginRoletype
    this.calHeight()
    this.getList()
    this.getUserList()
  },
  methods: {
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
    //   console.log('height',this.tableHeight)
    },
    // 新增通知用户
    addHandle(){
      this.dialogVisible = true
      this.formQuery = {
        meUserId: '',
        UseridSet:'',//设置
        SmsavailableNum: 0//条数
      }
    },
    // 编辑通知用户
    editHandle(item){
      // console.log('dd',item)
      this.formQuery = {
        meUserId: item.UserId,
        UseridSet:item.UseridSet,//设置
        SmsavailableNum:item.SmsavailableNum//条数
      }
      this.dialogVisible = true;
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1
      this.getList()
    },
    //取所有用户列表
    getUserList() {
        let data = {
            currpage: 1,
            perpage: 10000,
            keyword: '',
            strWorkState: '',
            strstation: '',
            strorgancode: ''
        }
        xz.getauthUserInfoByorgancode(data).then(res => {
            if (res.status == 'ok') {
                this.userList = res.msg;
            } else {
                this.userList = [];
            }
        })
    },
    getList(){
      this.listLoading = true
      xz.getBusiUersExtendList(this.listQuery).then(res =>{
        if(res.status == 'ok'){
          this.tableData = res.msg;
          this.totalcount = parseInt(res.totalcount);
        }else{
          this.tableData = [];
          this.totalcount = 0;
        }
        this.listLoading = false
      })
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.listQuery.currpage = Number(val);
      this.getList();
    },
    handleSizeChange(val) {
        this.listQuery.pagecount = Number(val);
        this.getList();
    },
    //确认修改
    confirmEdit(){
      this.$refs['formData'].validate((valid) => {
        if (valid) {
            // console.log('saveEnterHandle', this.formQuery)
            xz.upJbBusiUersExtend(this.formQuery).then(res => {
                // console.log('saveEnterHandle', res)
                if (res.status == 'ok') {
                  this.dialogVisible = false
                  this.getList()
                  this.$message({ type: 'success', message: '操作成功' })
                }else{
                  this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                }
            })
        } else {
            console.log('error submit!!');
            return false;
        }
      });
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sys_btns{
  display: flex;
  justify-content: flex-end;
  background-color: #fff;
  padding: 0 10px;
}
.p_roster_table.el-tabs{
  background-color: #fff;
}
</style>

<style>
.sys_dialog_box .el-select,
.sys_dialog_box .el-form-item__content{
  width: 300px;
}
.sys_config_table .el-table th > .cell {
  padding: 0;
}
.sys_config_table .el-table .cell {
  padding: 0;
}

</style>